// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { DateTimeField, FormType, RadioField } from "@hex-insights/forms";
import { SocialReactionFormValues } from "../../FormUtilities";
import { AnnouncementSelectField } from "../Announcement";
import { MediaAttachmentSelectField } from "../MediaAttachment";
import { NewsletterSelectField } from "../Newsletter";
import { PostSelectField } from "../Post";
import { BaseFieldProps } from "../shared";
import { UserSelectField } from "../User";

/**
 * Generic props for fields of the SocialReaction model.
 */
type FieldProps<K extends keyof SocialReactionFormValues.Base = keyof SocialReactionFormValues.Base> = BaseFieldProps<
	Pick<SocialReactionFormValues.Base, K>
>;

/**
 * Generic props for fields of the SocialReaction model that only appear in the detail form.
 */
type DetailFieldProps<K extends keyof SocialReactionFormValues.Detail = keyof SocialReactionFormValues.Detail> =
	BaseFieldProps<Pick<SocialReactionFormValues.Detail, K>>;

/**
 * Field component for the `createdAt` field of the SocialReaction model.
 */
export function CreatedAt({ formState, ...props }: DetailFieldProps<"createdAt">) {
	return (
		<DateTimeField
			formState={formState}
			name="createdAt"
			optional={FormType.isCreate(formState.formType)}
			precision="minute"
			{...props}
		/>
	);
}

/**
 * Field component for the `reaction` field of the SocialReaction model.
 */
export function Reaction({ formState, ...props }: FieldProps<"reaction">) {
	return (
		<RadioField
			formState={formState}
			name="reaction"
			options={SocialReactionFormValues.reactionOptions}
			blankValue={null}
			optional={FormType.isCreate(formState.formType)}
			{...props}
		/>
	);
}

export namespace Announcement {
	export type SelectProps = FieldProps<"announcementID"> &
		Omit<AnnouncementSelectField.SelectProps<SocialReactionFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `announcement` edge of the SocialReaction model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <AnnouncementSelectField.Select formState={formState} name="announcementID" optional {...props} />;
	}
}

export namespace Author {
	export type SelectProps = DetailFieldProps<"authorID"> &
		Omit<UserSelectField.SelectProps<SocialReactionFormValues.Detail>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `author` edge of the SocialReaction model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserSelectField.Select formState={formState} name="authorID" {...props} />;
	}
}

export namespace MediaAttachment {
	export type SelectProps = FieldProps<"mediaAttachmentID"> &
		Omit<MediaAttachmentSelectField.SelectProps<SocialReactionFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `mediaAttachment` edge of the SocialReaction model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <MediaAttachmentSelectField.Select formState={formState} name="mediaAttachmentID" optional {...props} />;
	}
}

export namespace Newsletter {
	export type SelectProps = FieldProps<"newsletterID"> &
		Omit<NewsletterSelectField.SelectProps<SocialReactionFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `newsletter` edge of the SocialReaction model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <NewsletterSelectField.Select formState={formState} name="newsletterID" optional {...props} />;
	}
}

export namespace Post {
	export type SelectProps = FieldProps<"postID"> &
		Omit<PostSelectField.SelectProps<SocialReactionFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `post` edge of the SocialReaction model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <PostSelectField.Select formState={formState} name="postID" optional {...props} />;
	}
}
